import React, { useEffect, useMemo, useState } from 'react';
// import AdminAccountHistoryDetail from './ActionHistoryDetail';
import rightChevron from '../../../../assets/Right-BlackChevron.svg';
import axiosApi from '../../../../core/interceptor/interceptor';
import { config } from '../../../../config';
import moment from 'moment';
import InfiniteScroll from 'react-infinite-scroll-component';
import _ from 'lodash';

export default function AdminAccountHistory(props) {
	const [searchString, setSearchString] = useState('');
	const [actionLogs, setActionLogs] = useState([]);
	const [page, setPage] = useState(1);

	const debouncedCheckSearchLog = useMemo(
		() => {
			return _.debounce((search_string) => {
				searchLog(search_string, false);
			}, 1000);
		},
		//eslint-disable-next-line
		[],
	);

	const searchLog = (search_string, append = true) => {
		axiosApi.get(`${config.apiUrl}/misc/action-logs`, { params: { page, search_string: (search_string || '').trim(), user_id: props?.data?.id} }).then((res) => {
			if (append) {
				setActionLogs(prev => [...prev, ...res.data.data.rows]);
			} else {
				setActionLogs(res.data.data.rows);
			}
		}).catch((err) => {
			console.error(err);
		})
	}

	useEffect(() => {
		searchLog(searchString);
		//eslint-disable-next-line
	}, [page]);

	useEffect(() => {
		if (page > 1) {
			setPage(1);
		}
		//eslint-disable-next-line
	}, [searchString]);
	return <>
		<div className="action-history">
			<div className="input-blk">
				<input type="text" placeholder="Search by an action.." onKeyUp={(e) => {
					setSearchString(e.target.value);
					debouncedCheckSearchLog(e.target.value);
				}} />
			</div>
			<div className="historyblk-wrapper">
				{/* <div className="history-blk">
                    <div className="left">
                        <span>Send Email - 6/10/21 - 1:34 PM</span>
                    </div>
                    <div className="right">
                        <img src={rightChevron} alt="right-chevron" />
                    </div>
                </div> */}
				<div className="historyblk-scroll" id="scrollableDiv" style={{ height: "calc(88vh - 3px)", overflow: "auto" }}>
					{Array.isArray(actionLogs) && actionLogs.length ? <InfiniteScroll
						dataLength={actionLogs.length}
						next={() => setPage(prev => prev + 1)}
						hasMore={true}
						scrollableTarget="scrollableDiv"
					>
						{
							actionLogs.map((log, idx) => (
								<div key={`action-log-${idx + 1}`} className="history-blk" onClick={() => props.selectedActionHistory(log)}>
									<div className="left">
										<span>{`${log?.message} - ${log?.created_at ? moment(log?.created_at).format('MM/DD/YYYY h:mm A') : 'N/A'}`}</span>
									</div>
									<div className="right">
										<img src={rightChevron} alt="right-chevron" />
									</div>
								</div>
							))
						}
					</InfiniteScroll> : <div className="noSeason">No record found.</div>
					}
				</div>
			</div>
		</div>
		{/* <div className="action-historyDetail">
            <p>Email sent to: 30,054 users. Sent to "Users". Recipients Selected: "All users". More details can be viewed in email archive.</p>
        </div> */}
	</>
}